import { Component, OnInit } from "@angular/core";
import { Location } from "@angular/common";

import { TranslateService } from "@ngx-translate/core";
import { GameService } from "../core/services/game.service";
import { Router } from "@angular/router";
import { EventsService } from '../core/services/events.service';
declare var $: any;
@Component({
  selector: "app-start-game",
  templateUrl: "./start-game.component.html",
  styleUrls: ["./start-game.component.scss"]
})
export class StartGameComponent implements OnInit {
  levels: any;
  currentLevel: number;
  currentStage: number;
  active = false;
  gamePlayed = false;
  runningGame = false;
  gameLimited = false;

  dailyplayed = false;
  freemiumlimit = false;

  constructor(
    private translate: TranslateService,
    private gameservice: GameService,
    public router: Router,
    private location: Location,
    private events: EventsService
  ) { }

  ngOnInit() {
    this.events.eventStart({eventType: 'GAME_PAGE_ACCESS', triggerType: 'access'});
    
    this.getGame();
  }

  ngAfterViewInit() {
    this.events.eventStart({ eventType: 'GAME_PAGE_LOADED', triggerType: 'access' });
  }

  goBack() {
    this.router.navigate(["/home"]);
  }

  getGame() {
    this.gameservice.getPlayerData().subscribe(player => {
      if (player["responseCode"] == 500) {
        localStorage.clear();
        this.router.navigate(['/login']);
      }
      this.currentLevel = player["responseData"].currentLevel;
      this.currentStage = player["responseData"].currentStage - 1;

      if(player["responseData"].products[0].status == 'ACTIVE' || player["responseData"].products[1].status == 'ACTIVE') {
        this.active = true;
      }

      if (this.currentLevel > 0) {
        this.runningGame = true;
      }
    });

    this.gameservice.getGame().subscribe(data => {
      this.levels = data["responseData"].levels.reverse();
      localStorage.setItem("structure", JSON.stringify(data["responseData"].levels));
      localStorage.setItem("lastQuestion", data["responseData"].levels[0].index)
    });
  }

  startGame() {


    this.gameservice.gameStart().subscribe(data => {
      if (data["responseCode"] < 400) {
        this.router.navigate(["/question"]);
      } else {
        if (data["responseData"].errorCode == 'FREEMIUM_LIMIT') {
          this.freemiumlimit = true;
        }
        if (data["responseData"].errorCode == 'SUB_DAILY_GAME_ALREADY_PLAYED') {
          this.gameLimited = true;
          this.dailyplayed = true;
        }

      }
    }, (erro) => {
      console.log(erro)
    });



  }

  stopGame() {
    this.events.eventStart({ eventType: 'GAME_PLAYED', triggerType: 'submit' });
    this.gameservice.gameFinish().subscribe(data => {
      this.events.eventStart({ eventType: 'GAME_PLAYED_SUCCESS', triggerType: 'success',responseData: JSON.stringify(data) });
      this.router.navigate(['/home'])
    });
  }
  close() {
    this.gamePlayed = false;
    this.gameLimited = false;
  }
}
